module.exports = __webpack_public_path__ + "az.no2.69ecb8cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/az.no2.jpg
// module id = tvnp
// module chunks = 0